<template>
  <v-container grid-list-xs>
    <v-card>
      <v-card-title>
        <DialogCashierBalance :user="user"
                              :cashier="cashierToClose"
                              @closed="cashierBalanceClosed" />
      </v-card-title>
      <v-tabs v-model="tabCashiers"
              color="deep-purple-accent-4"
              align-tabs="start">
        <v-tab value="cashiersList">Lista</v-tab>
        <v-tab value="cashiersMovements" v-if="groupAdmin || finances || admin">Livro Caixa</v-tab>
      </v-tabs>
      <v-window v-model="tabCashiers">
        <v-window-item value="cashiersList">
          <v-row>
            <v-col cols="12">
              <v-form :submit="submitSearch">
                <v-expansion-panels variant="accordion" v-model="filterPanel">
                  <v-expansion-panel value="searchFiltersPanel" rounded="lg">
                    <v-expansion-panel-title
                                             style="color:#000000 !important; 
                                       background-color: #e0e0e0ff; 
                                       opacity: 1 !important">
                      <v-row style="opacity: 1 !important">
                        <v-col cols="3">
                          <span class="v-card-title">Filtro de pesquisa</span>
                        </v-col>
                        <v-col cols="9" class="pe-10">
                          <DialogCreateUpdateCashier
                                                     :user="user"
                                                     v-model="editCashierModel"
                                                     :floatRight="true"
                                                     @created="createdCashier"
                                                     @updated="updatedCashier" />
                          <DialogCashierTransfer :floatRight="true" />
                        </v-col>
                      </v-row>
                    </v-expansion-panel-title>
                    <v-expansion-panel-text class="bg-grey-lighten-2">
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                                        v-model="filters.searchText"
                                        label="Nome"
                                        clearable
                                        density="compact"
                                        hide-details></v-text-field>
                        </v-col>
                        <v-col v-if="admin"
                               cols="12" md="6" sm="6">
                          <AutocompleteSelectGroup @selected="selectedGroup" />
                        </v-col>
                        <v-col cols="12" md="3" sm="4">
                          <v-select
                                    :items="[50, 100, 200, 500]"
                                    v-model="filters.itemsPerPage"
                                    label="Resultados por página"
                                    density="compact"
                                    hide-details></v-select>
                        </v-col>
                      </v-row>
                      <v-card-actions>
                        <v-btn color="warning" @click="clearFilters()">
                          <v-icon class="mr-2">mdi-broom</v-icon>
                          Limpar pesquisa
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" type="submit">
                          <v-icon class="mr-2">mdi-magnify</v-icon>
                          Pesquisar
                        </v-btn>
                      </v-card-actions>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-form>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-title>
                  <v-container>
                    <v-row justify="space-between" align="start" style="min-height: 80px;">
                      <v-col cols="11">
                        <v-select v-if="showSelectHeaders"
                                  label="Campos da tabela"
                                  item-title="title"
                                  return-object
                                  :items="headers"
                                  hide-details
                                  multiple
                                  clearable
                                  chips
                                  v-model="selectedHeaders"
                                  @update:modelValue="saveSelectedHeaders"></v-select>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="1" class="text-right">
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-btn icon density="compact"
                                   v-bind="props"
                                   variant="text">
                              <v-icon color="grey-lighten-1"
                                      @click="showSelectHeaders = !showSelectHeaders">
                                mdi-cog
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Configurar Cabeçalhos</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-title>
                <v-data-table
                              :headers="selectedHeaders"
                              :items="lstObjects"
                              :search="searchFilter"
                              :items-per-page="filters.itemsPerPage"
                              return-object
                              class="elevation-1"
                              hide-default-footer>
                  <template v-slot:bottom>
                    <div class="text-center pt-2">
                      <v-pagination
                                    :disabled="requestingApi"
                                    v-model="page"
                                    :length="maxPage"></v-pagination>
                    </div>
                  </template>
                  <template v-slot:item.is_human="{ value }">
                    <span>{{ value ? "PF" : "PJ" }}</span>
                  </template>
                  <template v-slot:item.type="{ value }">
                    <span>{{
                      $LEGAL_PEOPLE_TYPES_DIC[value]
                      ? $LEGAL_PEOPLE_TYPES_DIC[value].label
                      : value
                    }}</span>
                  </template>
                  <template v-slot:item.created_at="{ value }">
                    <span>{{
                      $moment(value).format("DD/MM/YYYY HH:mm")
                    }}</span>
                  </template>
                  <template v-slot:item.amount="{ value }">
                    <span>{{
                      $filters.currency(value, 'BRL')
                    }}</span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-menu>
                      <template v-slot:activator="{ props }">
                        <v-btn icon variant="text" v-bind="props"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="editCashierModel = item">
                          <v-list-item-title>
                            <v-icon color="primary" class="mr-2">mdi-pencil</v-icon>
                            Editar Caixa
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deleteCashier(item)" v-if="item.type === 0 || admin">
                          <v-list-item-title>
                            <v-icon color="error" class="mr-2">mdi-trash-can</v-icon>
                            Excluir Caixa
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="closeCashier(item)"
                                     v-if="item.type === 0 || groupAdmin || finances">
                          <v-list-item-title>
                            <v-icon color="secondary" class="mr-2">mdi-close</v-icon>
                            Fechamento de Caixa
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-window-item>
        <v-window-item value="cashiersMovements">
          <v-row>
            <v-col>
              <CashierMovements :user="user" />
            </v-col>
          </v-row>
        </v-window-item>
      </v-window>
    </v-card>
  </v-container>
</template>
<script>
import AutocompleteSelectGroup from "../components/AutocompleteSelectGroup.vue";
import CashierMovements from "./CashierMovements.vue";
import DialogCashierDeposit from "@/components/DialogCashierDeposit.vue";
import DialogCashierTransfer from '../components/DialogCashierTransfer.vue';
import DialogCreateUpdateCashier from "../components/DialogCreateUpdateCashier.vue";
import DialogCashierBalance from "../components/DialogCashierBalance.vue";
import api from '@/services'

export default {
  components: {
    AutocompleteSelectGroup,
    CashierMovements,
    DialogCreateUpdateCashier,
    DialogCashierTransfer,
    DialogCashierDeposit,
    DialogCashierBalance,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      showSelectHeaders: false,
      tabCashiers: "cashiersList",
      headers: [
        { title: "ID", align: "start", key: "id", sortable: true },
        { title: "Nome", align: "start", key: "name", sortable: true },
        { title: "Saldo", align: "end", key: "amount", sortable: true },
        { title: "Criado", align: "start", key: "created_at", sortable: true },
        { title: "Ações", key: "actions", align: "end", sortable: false },
      ],
      selectedHeaders: [],
      lstObjects: [],
      filters: {
        withUser: true,
        withGroup: true,
        special_filters: [],
        itemsPerPage: 1,
        is_human: null,
        type: null,
        group_id: null,
      },
      searchFilter: null,
      page: 1,
      maxPage: 1,
      filterPanel: "searchFiltersPanel",
      editCashierModel: {},
      dialogCreateEdit: false,
      cashierToClose: null,
    };
  },
  created() {
    var vm = this;

    if (vm.user?.access_level >= vm.$USER_ACCESS_LEVELS_DIC.ADMIN.value) {
      vm.headers.splice(-1, 0, { title: "Grupo", align: "end", key: "group.acronym", sortable: true });
    }
    vm.loadParameters();
  },
  mounted() { },
  activated() { },
  methods: {
    saveSelectedHeaders() {
      var vm = this;
      try {
        localStorage.setItem(
          "_cashier_list_headers",
          JSON.stringify(vm.selectedHeaders)
        );
      } catch (error) {
        console.error(error);
      }
    },
    selectedGroup(group) {
      var vm = this;
      vm.filters.group_id = group?.id;
    },
    loadParameters() {
      var vm = this;
      let _itemsPerPage = localStorage["_cashiers_itemsPerPage"];
      vm.filters.itemsPerPage = parseInt(_itemsPerPage || 10);

      try {
        let _headers = localStorage["_cashier_list_headers"];
        vm.selectedHeaders = _headers ? JSON.parse(_headers) : vm.headers;
      } catch (error) {
        vm.selectedHeaders = vm.headers;
      }
    },
    clearFilters() {
      var vm = this;
      vm.filters.searchText = null;
      vm.searchFilter = null;
      vm.filters.special_filters = [];
    },
    submitSearch(page) {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          api.cashier
            .list(vm.filters, page || 1)
            .then((result) => {
              vm.lstObjects = result?.data;
              vm.maxPage = Math.ceil(
                (result?.total || 1) / (result?.per_page || 10)
              );
              vm.$notify({
                type: "success",
                text: "Pesquisa concluída",
              });
              vm.filterPanel = "";
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    createdCashier(val) {
      const vm = this;

      vm.editCashierModel = {}
      vm.lstObjects.push(val);
      vm.lstObjects = vm.lstObjects.slice(0);
    },
    updatedCashier(val) {
      const vm = this;

      vm.lstObjects = vm.lstObjects.map(o => (o.id === val.id ? val : o));
    },
    closeCashier(cashier) {
      const vm = this;

      vm.cashierToClose = cashier;
    },
    deleteCashier(cashier) {
      const vm = this;

      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.cashier
            .delete(cashier.id)
            .then((result) => {
              vm.lstObjects = vm.lstObjects.filter(o => o.id !== cashier.id);
              vm.$notify({
                type: "success",
                text: "Caixa excluído",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    cashierBalanceClosed() {
      const vm = this;

      vm.cashierToClose = null;
    },
  },
  computed: {
    admin() {
      const vm = this;

      return vm.user?.access_level >= vm.$USER_ACCESS_LEVELS_DIC.ADMIN.value;
    },
    groupAdmin() {
      const vm = this;

      return vm.user?.access_level === vm.$USER_ACCESS_LEVELS_DIC.GROUP_ADMIN.value;
    },
    finances() {
      const vm = this;

      return vm.user?.access_level === vm.$USER_ACCESS_LEVELS_DIC.FINANCIAL_ADMIN.value;
    }
  },
  watch: {
    "filters.itemsPerPage"(newVal) {
      localStorage["_cashiers_itemsPerPage"] = newVal;
    },
    page(newVal) {
      var vm = this;
      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
  },
};
</script>